import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const fetchVisitDetail = async (visitId, setError, saveVisitDetail, logoutHandler) => {
  await apiCaller
    .get(`${URLS.VISITS}${visitId}/`)
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveVisitDetail(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export default fetchVisitDetail;
